export const getTinkoffIDParams = (location) => {
  if (!location.search) return {};
  const params = new URLSearchParams(location.search);
  const tinkoffTraceId = params.get("tinkoffTraceId") || null;
  return { tinkoffTraceId };
};
